import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import SaudiMofaMain from "./SaudiMofaMain";

const SaudiMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <SaudiMofaMain />
    </div>
  );
};

export default SaudiMofa;
